import { Button, Drawer, Typography } from "antd";
import dayjs from "dayjs";
import type { AmendmentRequest } from "@/features/journal-version-list";
import { UserBubbleLinkText } from "@/shared/ui";
import { JournalsAmendmentsRequisitesDiff } from "../journals-amendments-requisites-diff";
import { JournalsAmendmentsStatusBadge } from "../journals-amendments-status-badge";
import "./journals-amendments-preview-drawer.scss";

interface JournalsAmendmentsPreviewDrawerProps {
  request: AmendmentRequest | null;
  open: boolean;
  onClose: () => void;
  onOpenRequest: (request: AmendmentRequest) => void;
}

export const JournalsAmendmentsPreviewDrawer = ({
  request,
  open,
  onClose,
  onOpenRequest,
}: JournalsAmendmentsPreviewDrawerProps) => (
  <Drawer
    className="journals-amendments-preview-drawer"
    title="Краткая информация"
    width={480}
    open={open}
    onClose={onClose}
    destroyOnClose
    footer={
      request ? (
        <Button type="primary" block onClick={() => onOpenRequest(request)}>
          Открыть заявку
        </Button>
      ) : null
    }
  >
    {request ? (
      <div className="journals-amendments-preview-drawer__content">
        <div className="journals-amendments-preview-drawer__heading">
          <Typography.Title level={4}>
            Заявка № {request.requestNumber}
          </Typography.Title>
          <JournalsAmendmentsStatusBadge status={request.status} />
        </div>

        <dl className="journals-amendments-preview-drawer__meta">
          <dt>Тип изменений</dt>
          <dd>{request.changeType}</dd>
          <dt>Дата создания</dt>
          <dd>{dayjs(request.dateIso).format("DD.MM.YYYY HH:mm")} МСК</dd>
          <dt>Источник</dt>
          <dd>
            {request.requestSource === "SYSTEM"
              ? "Системная заявка"
              : `Создана вручную: ${request.changedBy}`}
          </dd>
          <dt>Причина</dt>
          <dd>{request.reason || "—"}</dd>
          <dt>Ответственный</dt>
          <dd>
            {request.responsible ? (
              <UserBubbleLinkText>
                {request.responsible}
              </UserBubbleLinkText>
            ) : (
              "—"
            )}
          </dd>
        </dl>

        {request.changesList ? (
          <JournalsAmendmentsRequisitesDiff
            changes={request.changesList}
            compact
          />
        ) : null}

        {request.isSuperseded ? (
          <div className="journals-amendments-preview-drawer__superseded">
            Заявка устарела: создана более новая заявка для этой организации.
          </div>
        ) : null}
      </div>
    ) : null}
  </Drawer>
);
